import React, {useState,useEffect,useCallback} from 'react'
import { useSelector } from 'react-redux'
import {selectUser} from '../features/userSlice'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import Parse from 'parse/dist/parse.min.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import {useDropzone} from 'react-dropzone'



export default function AddEvent() {
  const user = useSelector(selectUser)
  const [loadingBtn, setLoadingBtn] = useState(false)
  const [listEvents, setlistEvents] = useState([])
  const [loading, setLoading] = useState(false)
  const [reload, setReload] = useState(false)
  const [posterUrl, setPosterUrl] = useState(null)
  const [filePoster, setFilePoster] = useState(null)

 
 

  const formik = useFormik({
    initialValues: {
      categoryName:'',
      latitude:'',
      longitude:'', 
      position:'',    
    },
    validationSchema: Yup.object({
      categoryName: Yup.string().required(),    
       }),
    onSubmit: async (data) => {  
     
      if(filePoster) {
          setLoadingBtn(true)
        const pareseFile = new Parse.File('poster', filePoster)
        try {
            let poster = await  pareseFile.save()
            const EventsOferts = new Parse.Object('Events')
            EventsOferts.set('title',data.categoryName)
            EventsOferts.set('poster',poster)
           data.latitude !== '' && EventsOferts.set('location',new Parse.GeoPoint(data.latitude, data.longitude))
            EventsOferts.set('cant',data.position)
            try {               
                await EventsOferts.save()
                setLoadingBtn(false)
                setReload(!reload)
            } catch (error) {
                setLoadingBtn(false)
                console.log(error)                         
            }
        } catch (error) {
                 setLoadingBtn(false)
                console.log(error)  
        } 
      }  
            
    }
  })

  


useEffect(() => {
    (async () => {    
        let paserQuery = new Parse.Query('Events');                
        paserQuery.addAscending('cant');                   
        try {                          
            let events = await paserQuery.find();
            setlistEvents(events);            
            return true
        } catch (error) {
           console.log(error)       
           return false;
        }       
  
      })()
    
  }, [reload])


  const onDrop = useCallback(acceptedFiles => {
   const file = acceptedFiles[0]
   setFilePoster(acceptedFiles[0])
   setPosterUrl(URL.createObjectURL(file))
   }, [])
 
   const {getRootProps:getRootPropsImages, getInputProps:getInputPropsImages} = useDropzone({
     accept: 'image/jpeg,image/png',
     multiple:false,
     noKeyboard:true,
     onDrop
   })

 

if(loading) {
  return(
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 items-center mb-20">
   
    <main className="mt-5 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-8 lg:mt-10 lg:px-8 xl:mt-18">
    <div className="mt-6 grid grid-cols-1 gap-y-4 gap-x-2 sm:grid-cols-2 lg:grid-cols-10 xl:gap-x-1">
   
      <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
 
  </div>
       </main>
       </div>
  )
}

  if(!user) {
    return(
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 items-center mb-20">

<main className="mt-5 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-8 lg:mt-10 lg:px-8 xl:mt-18">
         <div className="sm:text-center ">
           <h1 className="text-6xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-8xl">
             <span className="block xl:inline">:( ¡Opp! Área Restringida</span>{' '}
             <span className="block text-cyan-600 xl:inline">Solo para usuarios Budgie</span>
           </h1>           
       
         </div>
       </main>

 </div> 
    )
}






  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 items-center mb-20">
   
    <main className="mt-5 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-8 lg:mt-10 lg:px-8 xl:mt-18">
  
    <h2 className="text-2xl font-medium tracking-tight text-gray-900">Eventos Publicitarios</h2>

                            <div className="mt-6 grid grid-cols-1 gap-y-4 gap-x-2 sm:grid-cols-2 lg:grid-cols-6 xl:gap-x-5">
                            {listEvents.map((product) => (
            <div key={product.id} className="group relative">
              <div className="w-full min-h-80 bg-gray-200 aspect-w-1 aspect-h-1 rounded-md overflow-hidden group-hover:opacity-75 lg:h-80 lg:aspect-none">
                <img
                  src={product.get('poster')._url}
                  alt={product.get('title')}
                  className="w-full h-full object-center object-cover lg:w-full lg:h-full"
                />
              </div>
              <div className="mt-4 flex justify-between">
                <div>
                  <h3 className="text-sm text-gray-700">
                    <a href={'#'}>
                      <span aria-hidden="true" className="absolute inset-0" />
                      {product.get('title')}
                    </a>
                  </h3>
                 {/* <p className="mt-1 text-sm text-gray-500">{product.color}</p>*/}
                </div>
               {/* <p className="text-sm font-medium text-gray-900">{product.price}</p>*/}
              </div>
            </div>
          ))}
                            </div>







                            <div>
        <div className="md:grid md:grid-cols-3 md:gap-6 mt-10">
          <div className="md:col-span-1">
            <div className="px-4 sm:px-0">
              <h3 className="text-lg font-medium leading-6 text-gray-900">Nuevo Evento Publicitarios</h3>
              <p className="mt-1 text-sm text-gray-600">
              Esta información se mostrará públicamente.
              </p>
            </div>
          </div>
          <div className="mt-5 md:mt-0 md:col-span-2">
            <form action="#" method="POST" onSubmit={formik.handleSubmit}>
              <div className="shadow sm:rounded-md sm:overflow-hidden">
                <div className="px-4 py-5 bg-white space-y-6 sm:p-6">
                <div className="col-span-6 sm:col-span-3">
                      <label htmlFor="categoryName" className="block text-sm font-medium text-gray-700">
                        Título del evento
                      </label>
                      <input
                        type="text"
                        name="categoryName"                        
                        id="categoryName"
                        value={formik.values.categoryName}
                        onChange={formik.handleChange}
                        autoComplete="given-name"
                        className="mt-1 focus:ring-cyan-500 focus:border-cyan-500 block border w-full h-8 p-4 shadow-sm sm:text-sm border-gray-400 rounded-md"
                      />
                       <label htmlFor="categoryName" className="block text-sm font-medium text-gray-700 mt-8">
                       Posición del evento
                      </label>
                       <input
                        type="number"
                        name="position"                        
                        id="position"
                        value={formik.values.position}
                        onChange={formik.handleChange}
                        autoComplete="given-name"
                        className="mt-1 focus:ring-cyan-500 focus:border-cyan-500 block border w-full h-8 p-4 shadow-sm sm:text-sm border-gray-400 rounded-md"
                      />


                    <div className="grid grid-cols-6 gap-6 my-8">
                    <div className="col-span-6 sm:col-span-3">
                      <label htmlFor="latitude" className="block text-sm font-medium text-gray-700">
                        Localización Latitud
                      </label>
                      <input
                        type="number"
                        name="latitude"
                        id="latitude"
                        value={formik.values.latitude}
                        onChange={formik.handleChange}
                        autoComplete="latitude"
                        className=" h-8 p-4 border mt-1 focus:ring-cyan-500 focus:border-cyan-500 block w-full shadow-sm sm:text-sm border-gray-400 rounded-md"
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                      <label htmlFor="longitude" className="block text-sm font-medium text-gray-700">
                      Localización Longitud
                      </label>
                      <input
                        type="number"
                        name="longitude"
                        id="longitude"
                        value={formik.values.longitude}
                        onChange={formik.handleChange}
                        autoComplete="longitude"
                        className=" h-8 p-4 border mt-1 focus:ring-cyan-500 focus:border-cyan-500 block w-full shadow-sm sm:text-sm border-gray-400 rounded-md"
                      />
                    </div> 
                    </div>

                    <div>
                    <label className="block text-sm font-medium text-gray-700">Poster del Evento</label>
                    {
                        <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-400 border-dashed rounded-md"
                    {...getRootPropsImages()}
                    >
                       <input {...getInputPropsImages()} />
                     <>
                        { posterUrl === null ?
                         <div className="space-y-1 text-center">
                      
                        <svg
                          className="mx-auto h-12 w-12 text-gray-400"
                          stroke="currentColor"
                          fill="none"
                          viewBox="0 0 48 48"
                          aria-hidden="true"
                        >
                          <path
                            d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <div className="flex text-sm text-gray-600">
                          <label
                            htmlFor="file-upload"
                            className="relative cursor-pointer bg-white rounded-md font-medium text-cyan-600 hover:text-cyan-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-cyan-500"
                          >
                            <span>Cargar un archivo</span>
                            <input id="file-upload" name="file-upload" type="file" className="sr-only" />
                          </label>
                          <p className="pl-1">o arrastrar y soltar</p>
                        </div>
                        <p className="text-xs text-gray-500">PNG, JPG, GIF hasta 1 MB</p>
                        </div>
                       :
                       <div className="w-full min-h-80 bg-gray-200 aspect-w-1 aspect-h-1 rounded-md overflow-hidden group-hover:opacity-75 lg:h-80 lg:aspect-none">
                       <img
                         src={posterUrl}
                         alt='poster'
                         className="w-40 h-full object-center object-cover lg:w-60 lg:h-80 rounded-md p-5"
                       />
                     </div>  
                    }



                        </>
                    </div>}
                  </div>

                    </div>                           
               
                </div>
                 
                
              


                <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
               
                  <button
                    type="submit"
                    className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-cyan-600 hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500"
                  >
                     { loadingBtn &&
               <span className=" items-center pr-3  ">
                 <FontAwesomeIcon icon={faSpinner} size='lg' className='animate-spin' />
                 </span>}
                   Crear Evento                
                   
                  </button>
              
                </div>
              </div>
            </form>
          </div>
        </div>
                            </div>            
                    
           </main>
   
     </div>
  )
}
